import React, {useEffect, useState} from "react";
import Spinner from "../_common/Spinner";
import GateSwitcherModal from "./GateSwitcherModal";

const GateSwitchersDetails = (props) => {
    const {gateSwitcher} = props;

    const [pending, setPending] = useState(true)

    useEffect(() => {
        setPending(true)
        setTimeout(() => setPending(false), 300)
    },[gateSwitcher])

    if(pending) {
        return (
            <div className='spinnerWrapper'>
                <Spinner size={300} />
            </div>
        )
    }

    return (
        <div className="DrainStationDetails">
            <GateSwitcherModal
                edit
                gateSwitcher={gateSwitcher}
                details
            />
        </div>
    )
}

export default GateSwitchersDetails;
